module.exports = __webpack_public_path__ + "assets/img/gary-min.b80f3cc3.jpeg";